import { createPortal } from 'react-dom';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { useProductStore } from '../../ProductProvider';
import { EFBattery, EFCompact, EFExpand, EFRuntime, EFUPS } from '../../detail/NewComps/B';
import Dialog from './Dialog';
import { US_Product_List, CA_Product_List, US_Product_Options, CA_Product_Options, AU_Product_List, AU_Product_Options } from './common';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { getSolarRecommand } from '@/service/solar-calculator';
import { IMG_R3_UPS, IMG_R3_PLUS, IMG_R3_MAX, IMG_R3_MAX_PLUS } from '../utils';
import Phone from '../icons/Phone';
import WiFi from '../icons/WiFi';
import Laptop from '../icons/Laptop';
import Light from '../icons/Light';

/**
 * ps：好乱，有点改不动🥲，把 B 复制了一份缩减后特供给 NA
 */
export default function TheComp() {
    const { t } = useLang('theProduct.OtherA');
    const { locale = 'us', query } = useRouter();
    const { pageStatus } = useProductStore();
    const [active, setActive] = useState(0);

    const timer = query._timer ? new Date(query._timer as string) : new Date();

    const ProductList = useMemo(() => {
        switch (locale) {
            case 'us':
                return US_Product_List;
            case 'ca':
                return CA_Product_List;
            case 'au':
                return AU_Product_List;
            default:
                return US_Product_List;
        }
    }, [locale]);

    const ProductOptions = useMemo(() => {
        switch (locale) {
            case 'us':
                return US_Product_Options;
            case 'ca':
                return CA_Product_Options;
            case 'au':
                return AU_Product_Options;
            default:
                return US_Product_Options;
        }
    }, [locale]);

    const List = [
        {
            pc: IMG_R3_UPS,
            title: t('item1_title'),
            desc: t('item1_desc'),
            link_more: ProductList[0]?.link_more,
            link_view: ProductList[0]?.link_view,
            icons: [
                {
                    icon: 'EFUPS',
                    title: t('item1_text1'),
                },
                {
                    icon: 'EFRuntime',
                    title: t('item1_text2'),
                },
                {
                    icon: 'EFCompact',
                    title: t('item1_text3'),
                },
                {
                    icon: 'EFBattery',
                    title: t('item1_text4'),
                },
            ],
        },
        {
            pc: IMG_R3_PLUS,
            title: t('item2_title'),
            desc: t('item2_desc'),
            link_more: ProductList[1]?.link_more,
            link_view: ProductList[1]?.link_view,
            icons: [
                {
                    icon: 'EFUPS',
                    title: t('item2_text1'),
                },
                {
                    icon: 'EFRuntime',
                    title: t('item2_text2'),
                },
                {
                    icon: 'EFExpand',
                    title: t('item2_text3'),
                },
                {
                    icon: 'EFBattery',
                    title: t('item2_text4'),
                },
            ],
        },
        {
            pc: IMG_R3_MAX,
            title: t('item3_title'),
            desc: t('item3_desc'),
            link_more: ProductList[2]?.link_more,
            link_view: ProductList[2]?.link_view,
            icons: [
                {
                    icon: 'EFUPS',
                    title: t('item3_text1'),
                },
                {
                    icon: 'EFRuntime',
                    title: t('item3_text2'),
                },
                {
                    icon: 'EFExpand',
                    title: t('item3_text3'),
                },
                {
                    icon: 'EFBattery',
                    title: t('item3_text4'),
                },
            ],
        },
        {
            pc: IMG_R3_MAX_PLUS,
            title: t('item4_title'),
            desc: t('item4_desc'),
            link_more: ProductList[2]?.link_more,
            link_view: ProductList[2]?.link_view,
            icons: [
                {
                    icon: 'EFUPS',
                    title: t('item4_text1'),
                },
                {
                    icon: 'EFRuntime',
                    title: t('item4_text2'),
                },
                {
                    icon: 'EFExpand',
                    title: t('item4_text3'),
                },
                {
                    icon: 'EFBattery',
                    title: t('item4_text4'),
                },
            ],
        },
    ].map((item, idx) => {
        const data = {
            ...item,
            ...ProductOptions[idx],
        };
        return data;
    });

    const [items, setItems] = useState(List);

    const handleChangeTab = (k: number) => {
        setActive(k);
    };

    // 获取价格信息
    useEffect(() => {
        (async () => {
            const getTemp = async (item: any, idx: number) => {
                const { productId, variantId } = item;
                const res = await getSolarRecommand({ productId, variantId }, locale);

                const temp = JSON.parse(JSON.stringify(items[idx]));
                if (res?.code === '0') {
                    temp.discountPrice = res?.data?.price;
                    temp.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                    temp.inventory = res?.data?.inventoryQuantity ?? undefined;
                    if (pageStatus === 'statusB') {
                        temp.isShowBuyBtn = true;
                        temp.isDialog = false;
                        temp.label = '';
                    }
                }
                return temp;
            };
            console.log({ ProductList });
            if (Array.isArray(ProductList)) {
                const promises = ProductList.map(getTemp);
                Promise.all(promises).then((res) => {
                    setItems([...res, ...items.slice(res.length)]);
                });
            } else {
                getTemp(ProductList, 0).then((res) => {
                    setItems([res, ...items.slice(1)]);
                });
            }
        })();
    }, []);

    const [showDialog, setShowDialog] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const handleOpenDialog = (i: any) => {
        setShowDialog(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: t('btn3'),
        });
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);
    const dateString = useMemo(() => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }, []);
    const fieldsMap = (locale: string) => {
        const maps: Record<string, any> = {
            au: {
                contactListId: ['147986536', '2042660893', '876714684'],
                fields: [
                    {
                        id: '11150',
                        type: 'multiple',
                        value: [2],
                        overwrite: false,
                    },
                    {
                        id: '4424',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '11149',
                        type: 'text',
                        value: dateString,
                        overwrite: true,
                    },
                ],
            },
        };
        return maps[locale] || [];
    };
    const configs = {
        needTerms: true,
        isMulti: true,
        termsHtml: (() => {
            const maps: any = {
                au: "I consent to the <a href='https://au.ecoflow.com/policies/terms-of-service' target='_blank'>Terms of Use</a> and <a href='https://account.ecoflow.com/agreement/en-au/PrivacyPolicy.html' target='_blank'>Privacy Policy</a>.",
            };
            return maps[locale] || '';
        })(),
        ...fieldsMap(locale),
        tipsObj: {
            successTips: t('successTips'),
        },
    };

    const productList = [
        {
            value: 7,
            label: t('win_product1'),
            checked: true,
            fields: [
                {
                    id: '11150',
                    type: 'multiple',
                    value: 7,
                    overwrite: false,
                },
                {
                    id: '9435',
                    type: 'multiple',
                    value: 15,
                    overwrite: false,
                },
            ],
        },
        {
            value: 8,
            label: t('win_product2'),
            checked: true,
            fields: [
                {
                    id: '11150',
                    type: 'multiple',
                    value: 7,
                    overwrite: false,
                },
                {
                    id: '9435',
                    type: 'multiple',
                    value: 15,
                    overwrite: false,
                },
            ],
        },
        {
            value: 9,
            label: t('win_product3'),
            checked: true,
            fields: [
                {
                    id: '11150',
                    type: 'multiple',
                    value: 7,
                    overwrite: false,
                },
                {
                    id: '9435',
                    type: 'multiple',
                    value: 15,
                    overwrite: false,
                },
            ],
        },
    ];

    const appItems = [
        {
            icon: <Phone />,
            text: t('F_item1_app1_text1'),
        },
        {
            icon: <WiFi />,
            text: t('F_item1_app1_text2'),
        },
        {
            icon: <Laptop />,
            text: t('F_item1_app1_text3'),
        },
        {
            icon: <Light />,
            text: t('F_item1_app1_text4'),
        },
    ];

    return (
        <div className={styles.TheComp} id="id-OtherA">
            <EfSpec className={'spec-x'} />
            <EfTitle hasAnimation={false}>{t('title')}</EfTitle>
            {/* <div className="email-wrapper">
                <div className={`gift gift-au`}>
                    <div className="box1">
                        <span className="get">{t('cc_1')}</span>
                    </div>
                    <div className="box2">
                        <div className="img">
                            <EfImg pc={'https://websiteoss.ecoflow.com/upload/image/1737713738845/ecocredit3x.png'} />
                        </div>
                    </div>
                </div>
            </div> */}
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className={`item${active === k ? ' active' : ''}`} key={k}>
                        <div className="item-top">
                            <div className="item-img">
                                <EfImg pc={item?.img || item?.pc} />
                            </div>
                            {item?.icon && (
                                <div className="item-img-icon">
                                    <EfImg pc={item?.icon} />
                                </div>
                            )}

                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                            <div className="item-combine-app">
                                <ul className="item-app2 item-apps">
                                    {appItems?.map((app: any, m: number) => (
                                        <li className="item-app" key={k + '_' + m}>
                                            <div className="item-app-icon">{app.icon}</div>
                                            <p className="item-app-text">{app.text}</p>
                                        </li>
                                    ))}
                                </ul>
                                <div className="border"></div>
                                <div className="total">
                                    <p className="total-sum">{item.backupTime}</p>
                                    <p className="backup">{t('F_backup')}</p>
                                </div>
                            </div>
                            <ul className="item-lists">
                                {item?.icons?.map((list: any, m: number) => (
                                    <li className="item-list" key={`${k}_${m}`}>
                                        <div className="list-icon">
                                            {list.icon === 'EFUPS' ? (
                                                <EFUPS id={`${k}_${m}`} />
                                            ) : list.icon === 'EFRuntime' ? (
                                                <EFRuntime id={`${k}_${m}`} />
                                            ) : list.icon === 'EFBattery' ? (
                                                <EFBattery id={`${k}_${m}`} />
                                            ) : list.icon === 'EFExpand' ? (
                                                <EFExpand id={`${k}_${m}`} />
                                            ) : (
                                                <EFCompact id={`${k}_${m}`} />
                                            )}
                                        </div>
                                        <p className="list-text">{list.title}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="item-footer">
                            {/* {item?.label ? (
                                <p className="item-label">{item?.label}</p>
                            ) : (
                                item?.discountPrice && (
                                    <div className="item-price-box">
                                        <span className="item-price price-discount">{FormatMoneyLocal(item?.discountPrice, locale)}</span>
                                        {item?.discountPrice !== item?.originalPrice && (
                                            <span className="item-price price-original">{FormatMoneyLocal(item?.originalPrice, locale)}</span>
                                        )}
                                    </div>
                                )
                            )} */}
                            {pageStatus === 'statusA' && (
                                <>
                                    <p className="item-label">{item?.label}</p>
                                    <>
                                        {item?.discountPrice && (
                                            <div className="item-price-box">
                                                <span className="item-price price-discount">{FormatMoneyLocal(item?.discountPrice, locale)}</span>
                                                {item?.discountPrice !== item?.originalPrice && (
                                                    <span className="item-price price-original">{FormatMoneyLocal(item?.originalPrice, locale)}</span>
                                                )}
                                            </div>
                                        )}
                                    </>
                                </>
                            )}

                            {pageStatus === 'statusB' && (
                                <>
                                    {item?.discountPrice && (
                                        <div className="item-price-box">
                                            <span className="item-price price-discount">{FormatMoneyLocal(item?.discountPrice, locale)}</span>
                                            {item?.discountPrice !== item?.originalPrice && (
                                                <span className="item-price price-original">{FormatMoneyLocal(item?.originalPrice, locale)}</span>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                            <div className={`item-btns`}>
                                {item?.isShowBuyBtn && (
                                    <EfLink
                                        className="btn shopify"
                                        href={item.link_more}
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'buy',
                                            product_name: item.title,
                                            position: `Product Detail_${t('btn2')}`,
                                        }}
                                    >
                                        {t('btn2')}
                                    </EfLink>
                                )}
                                {item?.isDialog && (
                                    <button className="btn notify" onClick={() => handleOpenDialog(item)}>
                                        {t('btn3')}
                                    </button>
                                )}
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items?.map((item: any, k: number) => (
                    <li className={`tab${active === k ? ' active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                        {item.title}
                    </li>
                ))}
            </ul>
            <EfSpec className={'spec-x'} />
            {showDialog && isClient && createPortal(<Dialog configs={{ ...configs, productList }} callback={() => setShowDialog(false)} />, document.body)}
        </div>
    );
}
